module.exports = __webpack_public_path__ + "img/merluzzo.ff86bee5.png";